module.exports = __webpack_public_path__ + "static/assets/48ab3eb8d0a3db9e1ddcb8e23c28b00f.svg";